/**
 * Preprocesses a raw JSON string from CMS data attributes so it can be
 * safely parsed. Handles:
 *  - Unicode smart/curly quotes (\u201C \u201D) → single quotes
 *  - ASCII "" wrapping content text (e.g. ""Hello"") → curly quotes,
 *    while preserving genuinely empty values ("":"")
 *  - HTML attribute double quotes inside values → single quotes
 *  - Unescaped backslashes, newlines, and tabs inside HTML values
 */
export default function preprocessJson(raw) {
  let s = raw;

  s = s.replace(/[\u201C\u201D]/g, "'");

  s = s.replace(/:""(?=[^,}\]])/g, ':"\u201C');
  s = s.replace(/(?<!:)""(?=[,}\]])/g, '\u201D"');

  s = s.replace(/"([^"]+)":"([^"]*<[^>]+>.*?)"/g, (match, fieldName, htmlContent) => {
    if (htmlContent.includes('\\"')) return match;

    const fixedHtml = htmlContent
      .replace(/(\w+)="([^"]*?)"/g, "$1='$2'")
      .replace(/\\/g, '\\\\')
      .replace(/[\r\n]/g, '\\n')
      .replace(/\t/g, '\\t');

    return `"${fieldName}":"${fixedHtml}"`;
  });

  return s;
}
